<template>
    <a-drawer
      :title="'outging-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>学院：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.departmentCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>学生姓名：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.studentName" />
        </div>
        <div class="input-box">
            <p>学号：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.studentNo" />
        </div>
        <div class="input-box">
            <p>学生类别：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.studentTypeCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xslbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>导师姓名：</p>
            <a-select 
                class="input" 
                allowClear
                show-search
                :filter-option="false"
                @search="teacherSearch"
                v-model="info.guideTeacherName"
                @change="teacherChange"
                option-label-prop="label"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.id" :label="item.teacherName">{{item.id}}-{{item.teacherName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>项目名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.projectName" />
        </div>
        <div class="input-box">
            <p>申请类别：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.outgoingApplyTypeCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in sqlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>申请学校名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.applyingCollegeName" />
        </div>
        <div class="input-box">
            <p>国家：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.abroadCountry" />
        </div>
        <div class="input-box">
            <p>派出时间：</p>
            <a-date-picker class="input" v-model="info.sendDate" @change="(date, dateString)=>{info.sendDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>拟回国时间：</p>
            <a-date-picker class="input" v-model="info.returnDate" @change="(date, dateString)=>{info.returnDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/international/outging'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    departmentCode:null,
                    studentName:null,
                    studentNo:null,
                    studentTypeCode:null,
                    guideTeacherName:null,
                    projectName:null,
                    outgoingApplyTypeCode:null,
                    applyingCollegeName:null,
                    abroadCountry:null,
                    sendDate:null,
                    returnDate:null,
                },
                xslbArr:[],
                sqlbArr:[],
                xyArr:[],
                jsArr:[],
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'XSLB',status:true}).then(res=>{
                    this.xslbArr=res.data.dicts;
                    this.info.studentTypeCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'WCSQLB',status:true}).then(res=>{
                    this.sqlbArr=res.data.dicts;
                    this.info.outgoingApplyTypeCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'XY',status:true}).then(res=>{
                    this.xyArr=res.data.dicts;
                    this.info.departmentCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.courseDirectorNo)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    decideDate:null,
                    consProjectTypeCode:null,
                    projectLevelCode:null,
                    courseNo:null,
                    courseName:null,
                    courseAttrCode:null,
                    courseDirectorNo:null,
                    courseDirectorName:null,
                    remark:null
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.guideTeacherName=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus','courseAttrName']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增outgoing成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改outgoing成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherSearch(value){
                getTeacher({teacherName:value}).then(res=>{
                    this.jsArr=res.data;
                })
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.courseDirectorName=this.jsArr[i].teacherName
                    }
                }
            },

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
